import React, { FC } from 'react';

interface Props {
  size?: number;
}

const EmptyEmail: FC<Props> = ({ size = 161 }) => (
  <svg width={size} height={(size * 126) / 161} viewBox="0 0 161 126" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      opacity="0.2"
      d="M92.1779 118.283C67.299 96.7812 35.2832 103.447 20.158 97.0855C-2.55686 87.5128 -13.5744 52.6829 36.3593 24.9827C86.2931 -2.7174 102.988 -6.35123 133.326 13.5484C157.601 29.4703 163.299 61.8522 160.138 81.1157C155.192 111.252 117.049 139.775 92.1779 118.283Z"
      fill="#A7BDE5"
    />
    <path
      d="M116.115 39.2524H60.8231C59.4521 39.2524 58.3407 40.3638 58.3407 41.7347V83.6576C58.3407 85.0285 59.4521 86.1399 60.8231 86.1399H116.115C117.486 86.1399 118.598 85.0285 118.598 83.6576V41.7347C118.598 40.3638 117.486 39.2524 116.115 39.2524Z"
      fill="#223762"
    />
    <path
      d="M114.326 39.2524H59.0338C57.6629 39.2524 56.5515 40.3638 56.5515 41.7347V83.6576C56.5515 85.0285 57.6629 86.1399 59.0338 86.1399H114.326C115.697 86.1399 116.808 85.0285 116.808 83.6576V41.7347C116.808 40.3638 115.697 39.2524 114.326 39.2524Z"
      fill="url(#paint0_linear)"
    />
    <path
      d="M58.8821 42.9194L86.6795 68.3226L113.985 42.9194"
      stroke="#112244"
      strokeWidth="0.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M59.0211 50.6562C64.8182 50.6562 69.5176 45.5844 69.5176 39.3281C69.5176 33.0718 64.8182 28 59.0211 28C53.2241 28 48.5247 33.0718 48.5247 39.3281C48.5247 45.5844 53.2241 50.6562 59.0211 50.6562Z"
      fill="#FF9F5B"
    />
    <path
      d="M57.4965 50.6562C63.2935 50.6562 67.9929 45.5844 67.9929 39.3281C67.9929 33.0718 63.2935 28 57.4965 28C51.6994 28 47 33.0718 47 39.3281C47 45.5844 51.6994 50.6562 57.4965 50.6562Z"
      fill="#FFD46A"
    />
    <path
      d="M57.9883 31.8811H56.9928C56.4222 31.8811 55.9596 32.3437 55.9596 32.9144V45.7294C55.9596 46.3001 56.4222 46.7627 56.9928 46.7627H57.9883C58.559 46.7627 59.0216 46.3001 59.0216 45.7294V32.9144C59.0216 32.3437 58.559 31.8811 57.9883 31.8811Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear"
        x1="28571.9"
        y1="6312.33"
        x2="26140.5"
        y2="9284.51"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4C93F4" />
        <stop offset="1" stopColor="#0B63DA" />
      </linearGradient>
    </defs>
  </svg>
);

export default EmptyEmail;
